import axios from 'axios';
const URL = 'https://limitless-stream-08042.herokuapp.com/auth'

export const login = async (data) => {
    try{
        const res = await axios.post(`${URL}/signin`,{
            email:data.email,
            password:data.password
        })

        return res;
    }
    catch(error) {
        console.log(error.message);
        throw error;
    }
}

export const register = async (data) => {
    try{
        const res = await axios.post(`${URL}/signup`,{
            email:data.email,
            password:data.password,
            firstname:data.firstName,
            lastname:data.lastName
        })

        console.log(res);
        return res;
    }
    catch(error) {
        console.log(error);
        throw error;
    }
}

export const CreateEmploye = async (data) => {
    try{
        const res = await axios.put(`${URL}/${data.id}`,{
            email:data.email,
            name:data.name
        })
    
        return res;
    }
    catch(err) {
        console.log(err);
        throw err;
    }
}

export const DeleteEmploye = async (data) => {
    try{
        console.log(data);
        const res = await axios.delete(`${URL}/${data.id}/${data.email}`,{
            email:data.email
        })

        return res;
    }
    catch (err) {
        console.log(err)
        throw err;
    }
}